import { VWCookieConsentDiv } from "./gui/initial/div/VWCookieConsentDiv";
import { VWThemeUtils } from "./gui/theme/VWThemeUtils";
import { Main } from "./Main";

export class CookieConsentGUI {
    private constructor() {}

    public static main(): void {
        document.body.hidden = true;

        Main.setNonce();
        Main.setTitle();
        Main.loadCharset();
        Main.loadStyles(); // To load the main style of the page, and the themes.

        CookieConsentGUI.loadMainDiv().then(() => { // To load the main div of the page.
            Main.initErrorDiv();
            Main.createToggleThemeDiv();
            Main.disableFurtherScriptsLoading();
            VWThemeUtils.adjustComponentsToTheme();  // This call will query the browser local storage.
        }, (error: Error) => {
            console.error(error);
        });

        VWThemeUtils.adjustComponentsToTheme();  // This call will query the browser local storage.

        // This is to prevent the content from being displayed before the styles are loaded and applied.
        window.addEventListener("load", () => {
            document.body.hidden = false;
        });
    }

    private static async loadMainDiv(): Promise<void> {
        const cookieConsentDiv: VWCookieConsentDiv = new VWCookieConsentDiv();

        cookieConsentDiv.pack();
        cookieConsentDiv.show();       

        document.body.appendChild(cookieConsentDiv.getDiv());
    }
}
